// Coordinate cart drawer visibility with the deferred Crisp loader without creating a premature $crisp stub.
const crispFallbackStyleId = 'cart-drawer-crisp-hide-style';
const crispFallbackRootClass = 'cart-drawer-hide-crisp';

let crispHiddenByCartDrawer = false;

function dispatchCrispVisibility(action) {
  if (Array.isArray(window.$crisp)) {
    window.$crisp.push(['do', `chat:${action}`]);
    return;
  }

  if (action === 'hide') {
    window.__waldCrispPendingVisibility = 'hide';
    return;
  }

  delete window.__waldCrispPendingVisibility;
}

function ensureCrispFallbackStyle() {
  if (document.getElementById(crispFallbackStyleId)) return;

  const style = document.createElement('style');
  style.id = crispFallbackStyleId;
  style.textContent = `
    html.${crispFallbackRootClass} #crisp-chatbox,
    html.${crispFallbackRootClass} #crisp-chatbox > div,
    html.${crispFallbackRootClass} .crisp-client,
    html.${crispFallbackRootClass} [data-crisp-chatbox],
    html.${crispFallbackRootClass} iframe[src*="crisp.chat"],
    html.${crispFallbackRootClass} iframe[title*="Crisp"],
    html.${crispFallbackRootClass} iframe[title*="crisp"] {
      opacity: 0 !important;
      visibility: hidden !important;
      pointer-events: none !important;
    }
  `;

  document.head.appendChild(style);
}

function isCartDrawerOpen() {
  return (
    document.body.classList.contains('cart-drawer-open') ||
    Boolean(document.querySelector('cart-drawer.active, cart-drawer[data-state="open"]'))
  );
}

function hideCrispChat() {
  if (crispHiddenByCartDrawer) return;

  ensureCrispFallbackStyle();
  document.documentElement.classList.add(crispFallbackRootClass);
  dispatchCrispVisibility('hide');
  crispHiddenByCartDrawer = true;
}

function showCrispChat() {
  if (!crispHiddenByCartDrawer) return;

  document.documentElement.classList.remove(crispFallbackRootClass);
  dispatchCrispVisibility('show');
  crispHiddenByCartDrawer = false;
}

function syncCartDrawerChatVisibility() {
  const shouldHideChat = isCartDrawerOpen();

  if (shouldHideChat) {
    hideCrispChat();
    return;
  }

  showCrispChat();
}

document.addEventListener('cart-drawer:open', syncCartDrawerChatVisibility);
document.addEventListener('cart-drawer:close', syncCartDrawerChatVisibility);
document.addEventListener('cart-drawer:toggle', syncCartDrawerChatVisibility);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', syncCartDrawerChatVisibility, { once: true });
} else {
  syncCartDrawerChatVisibility();
}
